import { render, staticRenderFns } from "./oa-clothing-oemorodm.vue?vue&type=template&id=ee38601a"
import script from "./oa-clothing-oemorodm.vue?vue&type=script&lang=ts"
export * from "./oa-clothing-oemorodm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports